import { render } from "./QuizEditPage.vue?vue&type=template&id=060ddc1f&scoped=true"
import script from "./QuizEditPage.vue?vue&type=script&lang=js"
export * from "./QuizEditPage.vue?vue&type=script&lang=js"

import "./QuizEditPage.vue?vue&type=style&index=0&id=060ddc1f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060ddc1f"]])

export default __exports__